import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import { ElMessage } from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import * as echarts from 'echarts'
// import 'echarts-gl' // 3d图表库
import Axios from "axios"
import 'lib-flexible/flexible.js'
import i18n from './i18n/index.js'
import dataView from '@jiaminghi/data-view'
import { installWebErrorLogger } from './util/webErrorLogger'


//配置Axios,element-plus(Vue3)
const app = createApp(App)
installWebErrorLogger(app, ElMessage)

//icon 的注册
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).use(ElementPlus, { locale: zhCn }).use(i18n).use(dataView).mount('#app')
